export default [
  {
    name: '名校生活剧透 —— 《 世界名校早知道 》',
    desc: '听听哈佛等世界名校的老师和学生讲述内部人士才知道的学术生活。',
    count: '累计2w+观看',
    tip: '* 提交补充信息后解锁',
    img: '//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/welfare/img-1.png'
  },
  {
    name: '哈佛原版小班课先导篇《幸福心理学 Positive Psychology 》',
    tag: '中文',
    desc: '“收到哈佛Offer”，“周游世界”，“实现一个亿小目标”，哪件事会让你感到无比幸福？<br/>如果告诉你，这些事可能并不能使你感到幸福，你会怎么想？',
    tip: '* 完成申请后解锁部分',
    img: '//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/welfare/img-2.png'
  },
  {
    name: '收听哈佛学霸一手校园生活博客',
    desc:
      '由来自哈佛各个学院的明星学霸为大家讲述大学校园生活的点点滴滴和可以从现在就开始自我提升的小技巧，锻炼英语听力的同时也可以更多了解美国顶尖大学的校园生活！',
    count: '累计5000+观看',
    tip: '* 完成申请后解锁部分',
    img: '//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/welfare/img-3.png'
  }
];
